<template lang="pug">
.cms
  v-container(fluid)
    v-menu(v-model="menu"
      :close-on-content-click="false"
      offset-y)
      template(v-slot:activator="{ on }")
        v-btn.mb-5(color="primary"
          outline
          v-on="on") 選擇內容
      v-list(color="red")
        template(v-for="item in items")
          v-list-group(v-if="item.items"
            :key="item.id"
            v-model="item.active")
            template(v-slot:activator)
              v-list-tile
                v-list-tile-content
                  v-list-tile-title {{ item.title }}
            v-list-tile(v-for="subItem in item.items"
              :key="subItem.title"
              :to="subItem.to"
              color="info"
              @click="menu = false")
              v-list-tile-content
                v-list-tile-title {{ subItem.title }}
          v-list-tile(v-else
            :to="item.to"
            color="info"
            @click="menu = false")
            v-list-tile-content
              v-list-tile-title {{ item.title }}
    router-view
</template>

<script>
export default {
  name: "Cms",
  data() {
    return {
      menu: false,
      items: [
        {
          id: "news",
          title: "最新消息",
          to: { name: "cms-news" }
        },
        {
          id: "activity",
          title: "活動花絮",
          to: { name: "cms-activity" }
        },
        {
          id: "calendar",
          title: "年度計畫",
          to: { name: "cms-calendar" }
        },
        {
          id: "intro",
          title: "同鄉會介紹",
          items: [
            {
              id: "purpose",
              title: "宗旨",
              to: { name: "cms-intro-purpose" }
            },
            {
              id: "rule",
              title: "章程",
              to: { name: "cms-intro-rule" }
            },
            {
              id: "pastchairman",
              title: "歷屆理事長",
              to: { name: "cms-intro-pastchairmans" }
            },
            {
              id: "advisors",
              title: "顧問團",
              to: { name: "cms-intro-advisors" }
            },
            {
              id: "18thstaffs",
              title: "18屆會務人員名冊",
              to: { name: "cms-intro-18staffs" }
            },
            {
              id: "17thstaffs",
              title: "17屆會務人員名冊",
              to: { name: "cms-intro-17staffs" }
            },
            {
              id: "16thstaffs",
              title: "16屆會務人員名冊",
              to: { name: "cms-intro-16staffs" }
            },
            {
              id: "15thstaffs",
              title: "15屆會務人員名冊",
              to: { name: "cms-intro-15staffs" }
            },
            {
              id: "14thstaffs",
              title: "14屆會務人員名冊",
              to: { name: "cms-intro-14staffs" }
            }
          ]
        },
        {
          id: "docs",
          title: "相關文件",
          to: { name: "cms-docs" },
          items: [
            {
              id: "officialdocs",
              title: "公文",
              to: { name: "cms-officialdocs" }
            },
            {
              id: "applications",
              title: "各式辦法",
              to: { name: "cms-applications" }
            }
          ]
        }
      ]
    };
  }
};
</script>
